import { Application } from "@hotwired/stimulus";
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers";

// Boots a single Stimulus application and autoloads every *_controller.js in
// this directory. Required from entrypoints/application.js.
//
// Stimulus observes the DOM via MutationObserver, so it coexists cleanly with
// Turbo Drive and rails-ujs (no navigation hooks needed).
const application = Application.start();

const context = require.context(".", true, /_controller\.js$/);
application.load(definitionsFromContext(context));

// Expose for debugging in the console.
window.Stimulus = application;

export { application };
